(() => {
  const normalize = (value) => value.toLocaleLowerCase('nl-NL').trim();

  class DpwHelpCenter {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-dhc-search-form]');
      this.input = root.querySelector('[data-dhc-search-input]');
      this.results = root.querySelector('[data-dhc-search-results]');
      this.items = [...root.querySelectorAll('[data-dhc-search-result]')];
      this.empty = root.querySelector('[data-dhc-search-empty]');
      this.status = root.querySelector('[data-dhc-search-status]');

      if (!this.form || !this.input || !this.results || !this.empty || !this.status) return;

      this.input.addEventListener('input', () => this.update());
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.root.addEventListener('focusout', (event) => this.onFocusout(event));
      document.addEventListener('pointerdown', (event) => this.onPointerdown(event));
    }

    update() {
      const query = normalize(this.input.value);

      if (!query) {
        this.close();
        return;
      }

      let matches = 0;
      this.items.forEach((item) => {
        const isMatch = normalize(item.dataset.searchText || '').includes(query);
        item.hidden = !isMatch;
        if (isMatch) matches += 1;
      });

      this.empty.hidden = matches !== 0;
      this.status.textContent = matches === 1 ? '1 passend hulponderwerp.' : `${matches} passende hulponderwerpen.`;
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.status.textContent = '';
      this.items.forEach((item) => {
        item.hidden = true;
      });
      this.empty.hidden = true;
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.input.value = '';
        this.close();
        this.input.focus();
      }
    }

    onSubmit(event) {
      const query = normalize(this.input.value);
      if (!query) return;

      event.preventDefault();
      this.update();
      const matches = this.items.filter((item) => !item.hidden);
      if (matches.length === 1) {
        window.location.assign(matches[0].querySelector('a').href);
      } else if (matches.length > 1) {
        matches[0].querySelector('a')?.focus();
      }
    }

    onFocusout(event) {
      if (!this.root.contains(event.relatedTarget)) this.close();
    }

    onPointerdown(event) {
      if (!this.root.contains(event.target)) this.close();
    }
  }

  document.querySelectorAll('[data-dpw-help-center]').forEach((root) => new DpwHelpCenter(root));
})();
